import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {LoginModel} from '../models/login-model';
import {Store} from '@ngrx/store';
import * as fromRoot from '../reducers';
import * as actions from '../actions/authentication';
import {Observable} from 'rxjs/Observable';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-login',
  template: `<div class="row justify-content-center" style="padding-top:20px;">
      <div class="col-md-4">
          <div class="card">
              <div class="card-header">
                  <h6 class="text-center">Log In</h6>
              </div>
              <div class="card-body">
                  <form (ngSubmit)="login()">
                    <input type="hidden" [ngModel]="returnUrl" [formControl]="loginForm.controls['returnUrl']"/>
                      <div class="form-group"
                           [ngClass]="{'has-error':!loginForm.controls['username'].valid && loginForm.controls['username'].touched}">
                          <input class="form-control" placeholder="User Name" [formControl]="loginForm.controls['username']">
                      </div>
                      <div class="form-group"
                           [ngClass]="{'has-error':!loginForm.controls['password'].valid && loginForm.controls['password'].touched}">
                          <input type="password" class="form-control" placeholder="Password" [formControl]="loginForm.controls['password']">
                      </div>
                      <div class="form-group"
                           [ngClass]="{'has-error':!loginForm.controls['totp'].valid && loginForm.controls['totp'].touched}">
                        <input class="form-control" placeholder="Authenticator Token" [formControl]="loginForm.controls['totp']">
                      </div>
                      <button class="btn btn-sm btn-outline-primary btn-block" [disabled]="working$ | async">
                        <span *ngIf="working$ | async">Logging In</span>
                        <span *ngIf="!(working$ | async)">Log In</span>
                      </button>
                  </form>
              </div>
          </div>
          <div class="row" *ngIf="showSignupLink">
              <div class="col-md-6 text-right">
                  <a routerLink="/register">Register for an account</a>
              </div>
              <div class="col-md-6">
                  <a routerLink="/forgotpassword">Forgot Password</a>
              </div>
          </div>
          <div class="row" *ngIf="!showSignupLink">
              <div class="col-md-12 text-center">
                  <a routerLink="/forgotpassword">Forgot Password</a>
              </div>
          </div>
      </div>
  </div>
  `,
})
export class LoginPageComponent implements OnInit {

  public loginForm: FormGroup;
  public working$: Observable<boolean>;
  public showSignupLink = false;

  private url: string;

  constructor(private store: Store<fromRoot.State>,
              private route: ActivatedRoute,
              private fb: FormBuilder,
              @Inject('ApplicationConfig') private config: any) {
    this.loginForm = this.fb.group({
      'username': [null, Validators.required],
      'password': [null, Validators.required],
      'returnUrl': [null],
      'totp': [null, Validators.required]
    });
    this.working$ = this.store.select(fromRoot.getAuthWorking);
    if (config.showSignupLink) {
      this.showSignupLink = config.showSignupLink;
    }
  }

  ngOnInit() {
    this.url = this.route.snapshot.queryParams['returnUrl'];
  }

  get returnUrl() {
    if (this.url) {
      return this.url;
    }
    return '/';
  }

  public login() {
    if (!this.loginForm.valid) {
      this.loginForm.controls['username'].markAsTouched();
      this.loginForm.controls['password'].markAsTouched();
      this.loginForm.controls['totp'].markAsTouched();
      return;
    }
    const loginData = this.loginForm.value as LoginModel;
    this.store.dispatch(new actions.LoginAction(loginData));
  }
}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/core/containers/login.ts